import { render, staticRenderFns } from "./TestToolbar.vue?vue&type=template&id=6e4513d0&scoped=true&"
import script from "./TestToolbar.vue?vue&type=script&lang=js&"
export * from "./TestToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4513d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpeedDial,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4513d0')) {
      api.createRecord('6e4513d0', component.options)
    } else {
      api.reload('6e4513d0', component.options)
    }
    module.hot.accept("./TestToolbar.vue?vue&type=template&id=6e4513d0&scoped=true&", function () {
      api.rerender('6e4513d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Start/TestToolbar.vue"
export default component.exports